// ProfileDetails.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { APP_CONFIG } from "../app-config";
import SidebarHeader from "../components/SidebarHeader";
import { encryptDataHybrid, apiCall } from "../utils/api";
import toast, { Toaster } from 'react-hot-toast';
import { IoWarningOutline } from "react-icons/io5";
import { GoVerified, GoUnverified } from "react-icons/go";
import BottomNav from "../components/bottom-menu";
import { BiNetworkChart } from "react-icons/bi";
import { FiArrowLeft } from "react-icons/fi";

const COLORS = APP_CONFIG.colors;
const currentYear = new Date().getFullYear();

const socialIcons = [
    {
        name: "WhatsApp",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
        ),
        link: APP_CONFIG.contacts.whatsapp,
    },
    {
        name: "Facebook",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
        ),
        link: APP_CONFIG.socialLinks.facebook,
    },
    {
        name: "Instagram",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.805.249 2.227.412.56.216.96.474 1.38.894.42.42.678.82.894 1.38.163.422.358 1.057.412 2.227.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.249 1.805-.412 2.227-.216.56-.474.96-.894 1.38-.42.42-.82.678-1.38.894-.422.163-1.057.358-2.227.412-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.805-.249-2.227-.412-.56-.216-.96-.474-1.38-.894-.42-.42-.678-.82-.894-1.38-.163-.422-.358-1.057-.412-2.227-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.054-1.17.249-1.805.412-2.227.216-.56.474-.96.894-1.38.42-.42.82-.678 1.38-.894.422-.163 1.057-.358 2.227-.412 1.266-.058 1.646-.07 4.85-.07zM12 0C8.741 0 8.333.014 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.058-1.28.072-1.689.072-4.948 0-3.259-.014-3.668-.072-4.948-.06-1.277-.262-2.148-.558-2.913-.306-.788-.718-1.459-2.126-1.384s-1.335-1.079-2.126-1.384c-.765-.296-1.636-.499-2.913-.558C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
            </svg>
        ),
        link: APP_CONFIG.socialLinks.instagram,
    },
    {
        name: "YouTube",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
        ),
        link: APP_CONFIG.socialLinks.youtube,
    },
];

function ProfileDetails() {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [shadow, setShadow] = useState(false);
    const [balance, setBalance] = useState(localStorage.getItem("balance") || "0.00");
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [selectedRating, setSelectedRating] = useState(0);
    const [hoveredRating, setHoveredRating] = useState(0);
    const [feedbackText, setFeedbackText] = useState("");
    const [menuItems, setMenuItems] = useState([{
        label: "Edit Profile",
        path: "/profile-edit",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    },
    {
        label: "Refer & Earn",
        path: "/refer-code",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" /><line x1="12" y1="22" x2="12" y2="7" /></svg>,
    },
    {
        label: "Transaction History",
        path: "/history",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
    },
    {
        label: "Rate Us",
        path: "#",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
    },
    {
        label: "Write to Us",
        path: "#",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>,
    },
    {
        label: "Help & Support",
        path: "/support-center",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>,
    },
    {
        label: `About ${APP_CONFIG.app.name}`,
        path: "/about",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>,
    }])

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const result = await apiCall(
                    "profile-fetch",
                    {},
                    true
                );

                if (result.status === true) {
                    setProfile(result.profile);
                    if (result.profile.role === "7") {
                        setMenuItems(prev => [
                            ...prev,
                            {
                                label: "Agent Network",
                                path: "/agent/dashboard",
                                icon: (c) => <BiNetworkChart size={20} color={c} />,
                            }
                        ]);
                    }
                } else {
                    toast.error(result.message || "Failed to fetch profile");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            } finally {
                setLoading(false);
            }
        }

        const fetchBalance = async () => {
            try {
                const result = await apiCall(
                    "balance",
                    {},
                    true
                );
                if (result.status === true) {
                    setBalance(result.data.balance);
                    localStorage.setItem("balance", result.data.balance)
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            }
        }

        fetchProfile();
        fetchBalance();
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            setShadow(window.scrollY > 10);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate("/login", { replace: true });
        window.history.pushState(null, "", "/login");
    };

    const getInitials = (name) => {
        return name
            ?.split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2) || 'U';
    };

    const handleWriteToUs = () => {
        window.location.href = `mailto:${APP_CONFIG.contacts.email}`;
    };

    const handleRateUs = () => {
        setShowRatingModal(true);
        setSelectedRating(0);
        setHoveredRating(0);
        setFeedbackText("");
    };

    const handleRatingSubmit = () => {
        if (selectedRating >= 4) {
            // Open Play Store
            window.open('https://play.google.com/store/apps/details?id=com.pezo.app', '_blank', "noopener,noreferrer");
            setShowRatingModal(false);
        } else if (selectedRating >= 1 && selectedRating <= 3) {
            toast.success("Thank you for your feedback!");
            setShowRatingModal(false);
        }
    };

    const handleStarClick = (rating) => {
        setSelectedRating(rating);
        if (rating >= 4) {
            setTimeout(() => {
                window.open('https://play.google.com/store/apps/details?id=com.pezo.app', '_blank', "noopener,noreferrer");
                setShowRatingModal(false);
            }, 500);
        }
    };

    const closeRatingModal = () => {
        setShowRatingModal(false);
        setSelectedRating(0);
        setHoveredRating(0);
        setFeedbackText("");
    };

    if (loading) {
        return (
            <SidebarHeader>
                <div className="flex items-center gap-3 pb-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                    >
                        <FiArrowLeft className="text-xl" />
                    </button>
                    <h1 className="text-lg font-semibold text-gray-800">
                        Profile
                    </h1>
                </div>
                <div className="max-w-7xl mx-auto mb-16">
                    <div className="text-center py-12">
                        <div className="w-10 h-10 rounded-full animate-spin mx-auto mb-4" style={{ border: `3px solid ${COLORS.primaryColor}33`, borderTopColor: COLORS.primaryColor }} />
                        <div className="text-sm font-medium" style={{ color: COLORS.textSecondary }}>
                            Loading profile...
                        </div>
                    </div>
                </div>
                <Toaster />
                <div className="lg:hidden">
                    <BottomNav />
                </div>
            </SidebarHeader>
        );
    }

    return (
        <SidebarHeader>
            <div className="flex items-center gap-3 pb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                >
                    <FiArrowLeft className="text-xl" />
                </button>
                <h1 className="text-lg font-semibold text-gray-800">
                    Profile
                </h1>
            </div>
            <div className="max-w-7xl mx-auto mb-16">
                {/* Profile Header */}
                <div className="pt-6 pb-4 flex flex-col items-center">
                    {/* Profile Avatar */}
                    <div
                        className="w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold mb-3"
                        style={{
                            background: `linear-gradient(135deg, ${COLORS.primaryColor}, ${COLORS.primaryLight})`,
                            color: '#FFFFFF'
                        }}
                    >
                        {getInitials(profile?.name)}
                    </div>

                    {/* Name */}
                    <h2
                        className="text-lg font-bold mb-1"
                        style={{
                            color: COLORS.textPrimary,
                        }}
                    >
                        {profile?.name || 'User'}
                    </h2>

                    {/* Email */}
                    <p
                        className="text-sm mb-1"
                        style={{
                            color: COLORS.textSecondary,
                        }}
                    >
                        {profile?.email || 'No email'}
                    </p>

                    {/* Mobile */}
                    <p
                        className="text-sm mb-4"
                        style={{
                            color: COLORS.textSecondary,
                        }}
                    >
                        {profile?.mobile || 'No mobile'}
                    </p>

                    {/* Verification Status Row with Icons */}
                    <div className="flex gap-2 w-full max-w-md">
                        <div
                            className="flex-1 px-3 py-2 rounded-lg text-center flex items-center justify-center gap-1.5"
                            style={{
                                background: profile?.email_verification === "1"
                                    ? `${COLORS.primaryColor}15`
                                    : `${COLORS.borderColor}30`,
                                border: `1px solid ${profile?.email_verification === "1"
                                    ? COLORS.primaryColor
                                    : COLORS.borderColor}30`
                            }}
                        >
                            {profile?.email_verification === "1" ? (
                                <GoVerified size={14} color={COLORS.primaryColor} />
                            ) : (
                                <GoUnverified size={14} color={COLORS.textSecondary} />
                            )}
                            <p
                                className="text-xs font-medium"
                                style={{
                                    color: profile?.email_verification === "1"
                                        ? COLORS.primaryColor
                                        : COLORS.textSecondary,
                                }}
                            >
                                Email
                            </p>
                        </div>
                        <div
                            className="flex-1 px-3 py-2 rounded-lg text-center flex items-center justify-center gap-1.5"
                            style={{
                                background: profile?.mobile_verification === "1"
                                    ? `${COLORS.primaryColor}15`
                                    : `${COLORS.borderColor}30`,
                                border: `1px solid ${profile?.mobile_verification === "1"
                                    ? COLORS.primaryColor
                                    : COLORS.borderColor}30`
                            }}
                        >
                            {profile?.mobile_verification === "1" ? (
                                <GoVerified size={14} color={COLORS.primaryColor} />
                            ) : (
                                <GoUnverified size={14} color={COLORS.textSecondary} />
                            )}
                            <p
                                className="text-xs font-medium"
                                style={{
                                    color: profile?.mobile_verification === "1"
                                        ? COLORS.primaryColor
                                        : COLORS.textSecondary,
                                }}
                            >
                                Mobile
                            </p>
                        </div>
                        <div
                            className="flex-1 px-3 py-2 rounded-lg text-center flex items-center justify-center gap-1.5"
                            style={{
                                background: profile?.kyc_verification === "1"
                                    ? `${COLORS.primaryColor}15`
                                    : `${COLORS.borderColor}30`,
                                border: `1px solid ${profile?.kyc_verification === "1"
                                    ? COLORS.primaryColor
                                    : COLORS.borderColor}30`
                            }}
                        >
                            {profile?.kyc_verification === "1" ? (
                                <GoVerified size={14} color={COLORS.primaryColor} />
                            ) : (
                                <GoUnverified size={14} color={COLORS.textSecondary} />
                            )}
                            <p
                                className="text-xs font-medium"
                                style={{
                                    color: profile?.kyc_verification === "1"
                                        ? COLORS.primaryColor
                                        : COLORS.textSecondary,
                                }}
                            >
                                KYC
                            </p>
                        </div>
                    </div>

                    {/* Complete Verification Button */}
                    {profile?.kyc_verification !== "1" && (
                        <button
                            onClick={() => navigate('/kyc-verification')}
                            className="w-full max-w-md py-2.5 rounded-lg mt-4 text-sm font-semibold transition-all duration-200 active:scale-98"
                            style={{
                                background: COLORS.primaryColor,
                                color: COLORS.textOnPrimary,
                                borderRadius: COLORS.borderRadius,
                                opacity: profile?.kyc_verification === "1" ? 0.6 : 1,
                                cursor: profile?.kyc_verification === "1" ? 'default' : 'pointer'
                            }}
                            disabled={profile?.kyc_verification === "1"}
                        >
                            {profile?.kyc_verification === "1" ? '✅ Verified' : 'Complete Verification'}
                        </button>
                    )}

                    {(profile?.kyc_verification === "1" && profile?.pan_verification !== "1") &&
                        <button
                            onClick={() => navigate('/kyc-verification')}
                            className="w-full max-w-md py-2.5 mt-4 rounded-lg text-sm font-semibold transition-all duration-200 active:scale-98"
                            style={{
                                background: COLORS.primaryColor,
                                color: COLORS.textOnPrimary,
                                borderRadius: COLORS.borderRadius,
                                opacity: profile?.pan_verification === "1" ? 0.6 : 1,
                                cursor: profile?.pan_verification === "1" ? 'default' : 'pointer'
                            }}
                            disabled={profile?.pan_verification === "1"}
                        >
                            {profile?.pan_verification === "1" ? '✅ Verified' : 'PAN Verification'}
                        </button>
                    }
                </div>

                {/* Menu Items - Card Design */}
                <div className="flex-1 pt-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {menuItems.map((item, index) => (
                            <div
                                key={`${item.path}-${index}`}
                                onClick={() => {
                                    if (item.label === "Write to Us") {
                                        handleWriteToUs();
                                    } else if (item.label === "Rate Us") {
                                        handleRateUs();
                                    } else {
                                        navigate(item.path);
                                    }
                                }}
                                className="flex items-center gap-3.5 p-4 cursor-pointer transition-all duration-200 active:scale-98 rounded-xl hover:shadow-md"
                                style={{
                                    background: COLORS.bgColor,
                                    border: `1px solid ${COLORS.borderColor}`,
                                    borderRadius: COLORS.borderRadius,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = COLORS.primaryColor;
                                    e.currentTarget.style.boxShadow = `0 4px 16px ${COLORS.primaryColor}20`;
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = COLORS.borderColor;
                                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
                                    e.currentTarget.style.transform = "translateY(0)";
                                }}
                            >
                                <div
                                    className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                                    style={{
                                        background: `${COLORS.primaryColor}15`,
                                        transition: "all 0.3s ease"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = COLORS.primaryColor;
                                        const svg = e.currentTarget.querySelector('svg');
                                        if (svg) {
                                            svg.style.stroke = COLORS.textOnPrimary;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = `${COLORS.primaryColor}15`;
                                        const svg = e.currentTarget.querySelector('svg');
                                        if (svg) {
                                            svg.style.stroke = COLORS.primaryColor;
                                        }
                                    }}
                                >
                                    {item.icon(COLORS.primaryColor)}
                                </div>
                                <span
                                    className="flex-1 text-sm font-medium"
                                    style={{ color: COLORS.textPrimary }}
                                >
                                    {item.label}
                                </span>
                                <div
                                    className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                                    style={{
                                        background: `${COLORS.primaryColor}10`,
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={COLORS.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="9 18 15 12 9 6" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Logout Button */}
                <div className="px-4 pb-6 pt-4 flex item-center justify-center">
                    <button
                        onClick={() => setShowLogoutModal(true)}
                        className="p-3.5 rounded-xl flex items-center justify-center gap-2.5 transition-all duration-200 active:scale-98"
                        style={{
                            background: `${COLORS.errorColor}10`,
                            border: `1px solid ${COLORS.errorColor}30`,
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={COLORS.errorColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                        <span
                            className="text-sm font-semibold"
                            style={{ color: COLORS.errorColor }}
                        >
                            Logout
                        </span>
                    </button>
                </div>

                <div
                    style={{
                        padding: "0 16px 100px",
                        textAlign: "center",
                        background: "transparent",
                    }}
                >
                    <div
                        style={{
                            height: "1px",
                            width: "100%",
                            background: COLORS.borderColor,
                            marginBottom: "24px",
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "24px",
                            marginBottom: "32px",
                        }}
                    >
                        {socialIcons.map((social) => (
                            <a
                                key={social.name}
                                href={social.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: COLORS.primaryColor,
                                    transition: "transform 0.2s ease",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                            >
                                {social.icon}
                            </a>
                        ))}
                    </div>

                    <h2
                        style={{
                            fontSize: "18px",
                            fontWeight: 700,
                            color: COLORS.textPrimary,
                            marginBottom: "4px"
                        }}
                    >
                        {APP_CONFIG.company.name}
                    </h2>

                    <div
                        style={{
                            fontSize: "12px",
                            color: COLORS.textSecondary,
                            display: "flex",
                            flexDirection: "column",
                            gap: "6px",
                            opacity: 0.8,
                        }}
                    >
                        <span>Version {APP_CONFIG.appVersion} © {currentYear} </span>
                        <span style={{ fontWeight: 500 }} >
                        </span>
                    </div>
                </div>

                {/* Bottom Navigation - Hidden on desktop (lg and above) */}
                <div className="lg:hidden">
                    <BottomNav />
                </div>

                <Toaster />

                {/* Rating Centered Modal */}
                {showRatingModal && (
                    <div
                        className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1100] animate-fadeIn"
                        onClick={closeRatingModal}
                    >
                        <div
                            className="w-full max-w-md mx-4 p-6 rounded-2xl transform transition-all duration-300 animate-scaleIn"
                            style={{
                                background: COLORS.bgColor,
                                borderRadius: COLORS.borderRadius,
                                boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                                maxHeight: '90vh',
                                overflowY: 'auto'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Close Button */}
                            <button
                                onClick={closeRatingModal}
                                className="absolute top-4 right-4 p-1 rounded-full hover:bg-gray-100 transition-colors"
                                style={{ color: COLORS.textSecondary }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>

                            <h3
                                className="text-lg font-bold text-center mb-2"
                                style={{ color: COLORS.textPrimary }}
                            >
                                Rate Us
                            </h3>
                            <p
                                className="text-sm text-center mb-6"
                                style={{ color: COLORS.textSecondary }}
                            >
                                How would you rate your experience?
                            </p>

                            {/* Star Rating */}
                            <div className="flex justify-center gap-3 mb-6">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <button
                                        key={star}
                                        onClick={() => handleStarClick(star)}
                                        onMouseEnter={() => setHoveredRating(star)}
                                        onMouseLeave={() => setHoveredRating(0)}
                                        className="text-4xl transition-all duration-200 transform hover:scale-110"
                                        style={{
                                            color: (hoveredRating || selectedRating) >= star
                                                ? '#FFB800'
                                                : COLORS.borderColor,
                                        }}
                                    >
                                        ★
                                    </button>
                                ))}
                            </div>

                            {/* Feedback Text Area - Only shown for 3 stars or below */}
                            {selectedRating >= 1 && selectedRating <= 3 && (
                                <div className="mb-6">
                                    <textarea
                                        placeholder="Please tell us how we can improve..."
                                        value={feedbackText}
                                        onChange={(e) => setFeedbackText(e.target.value)}
                                        className="w-full p-3 rounded-lg text-sm resize-none"
                                        rows="4"
                                        style={{
                                            background: COLORS.surfaceColor,
                                            color: COLORS.textPrimary,
                                            border: `1px solid ${COLORS.borderColor}`,
                                            outline: 'none'
                                        }}
                                    />
                                    <button
                                        onClick={handleRatingSubmit}
                                        className="w-full mt-2 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 active:scale-98"
                                        style={{
                                            background: COLORS.primaryColor,
                                            color: COLORS.textOnPrimary,
                                            borderRadius: COLORS.borderRadius,
                                        }}
                                    >
                                        Submit Feedback
                                    </button>
                                </div>
                            )}

                            {/* Close Button */}
                            <button
                                onClick={closeRatingModal}
                                className="w-full py-2.5 rounded-lg text-sm font-medium transition-all duration-200 active:scale-98"
                                style={{
                                    background: COLORS.surfaceColor,
                                    color: COLORS.textSecondary,
                                    border: `1px solid ${COLORS.borderColor}`,
                                    borderRadius: COLORS.borderRadius,
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}

                {/* Logout Modal */}
                {showLogoutModal && (
                    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1100] animate-fadeIn">
                        <div
                            className="w-[calc(100%-48px)] max-w-[320px] p-6 rounded-card text-center animate-scaleIn"
                            style={{
                                background: COLORS.bgColor,
                                borderRadius: COLORS.borderRadius
                            }}
                        >
                            <h3
                                className="text-lg font-bold mb-2"
                                style={{ color: COLORS.textPrimary }}
                            >
                                Logout
                            </h3>
                            <p
                                className="text-sm mb-6"
                                style={{ color: COLORS.textSecondary }}
                            >
                                Are you sure you want to logout?
                            </p>
                            <div className="flex gap-3">
                                <button
                                    onClick={() => setShowLogoutModal(false)}
                                    className="flex-1 h-11 border rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 active:scale-98"
                                    style={{
                                        background: COLORS.surfaceColor,
                                        color: COLORS.textPrimary,
                                        borderColor: COLORS.borderColor,
                                        borderRadius: COLORS.borderRadius,
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleLogout}
                                    className="flex-1 h-11 border-none rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 active:scale-98"
                                    style={{
                                        background: COLORS.errorColor,
                                        color: COLORS.textOnPrimary,
                                        borderRadius: COLORS.borderRadius,
                                    }}
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <style>
                    {`
                    .active\\:scale-98:active {
                        transform: scale(0.98);
                    }
                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    @keyframes scaleIn {
                        from { 
                            opacity: 0;
                            transform: scale(0.9);
                        }
                        to { 
                            opacity: 1;
                            transform: scale(1);
                        }
                    }
                    @keyframes slideUp {
                        from {
                            transform: translateY(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateY(0);
                            opacity: 1;
                        }
                    }
                    .animate-fadeIn {
                        animation: fadeIn 0.2s ease forwards;
                    }
                    .animate-scaleIn {
                        animation: scaleIn 0.2s ease forwards;
                    }
                    .animate-slideUp {
                        animation: slideUp 0.3s ease forwards;
                    }
                    .animate-spin {
                        animation: spin 1s linear infinite;
                    }
                    @keyframes spin {
                        from {
                            transform: rotate(0deg);
                        }
                        to {
                            transform: rotate(360deg);
                        }
                    }
                `}
                </style>
            </div>
        </SidebarHeader>
    );
}

export default ProfileDetails;